export default __webpack_public_path__ + "static/media/13.99f014ae.jpeg";